module.exports = __webpack_public_path__ + "media/taipei/taipei-feacad0f.jpg";